import { FC, ReactElement, useEffect } from 'react'

import { MessagesContainer } from '@/containers'
import { useChatConnection } from '@/context/ChatConnectionContext'
import { fetchChatUsers } from '@/redux/chatUsers/chatUsersActions'
import { useTypedDispatch, useTypedSelector } from '@/redux/store'

export const ConnectedMessages: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const { client, hasConnectionError } = useChatConnection()
    const { chatUsers, isLoading: isLoadingChatUsers } = useTypedSelector(state => state.chatUsersReducer)

    useEffect(() => {
        dispatch(fetchChatUsers())
    }, [dispatch])

    return (
        <MessagesContainer
            client={client ?? null}
            hasConnectionError={hasConnectionError}
            chatUsers={chatUsers}
            isLoadingChatUsers={isLoadingChatUsers}
        />
    )
}
